import $ from 'jquery';
import common from '../base/common';
import Form from '../components/form';
import scroller from '../components/scroller'

class Menu{

    constructor(){

        this.open = false;
        this.contactsOpen = false;
        this.privacyOpen = false;
        this.closeAll = false;
        this.$toggler = $('#menu-button');
        this.$menu = $('.Menu');
        this.$contacts = $('.Contacts');
        this.$privacy = $('.Privacy');
        this.$contactsToggler = this.$menu.find('.bt-contacts');

        this.toggle = this.toggle.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.showContacts = this.showContacts.bind(this);
        this.onResize = this.onResize.bind(this);
        this.showContactsSingle = this.showContactsSingle.bind(this);
        this.showPrivacy = this.showPrivacy.bind(this);

        this.$toggler.on('click', this.toggle);
        this.$menu = $('.Menu');
        this.$navLi = this.$menu.find('.Menu__Nav li');
        this.$reserved = this.$menu.find('.Menu__Reserved');
        this.$languages = this.$menu.find('.Menu__Languages');

        this.$navLi.on('click','a:not(.bt-contacts)', this.hide);
        this.$contactsToggler.on('click', this.showContacts);
        $('#footer-contacts').on('click', this.showContactsSingle);
        $('.privacy-bt').on('click', this.showPrivacy);

        common.$window.on('resize', this.onResize);

        new Form($('.Form'));

        this.reset();

    }

    reset(){

        this.$menu.hide();
        TweenMax.set(this.$menu,{width: 0, x: 0});
        TweenMax.set(this.$navLi,{opacity: 0});
        TweenMax.set(this.$reserved,{opacity: 0, y: 100});
        TweenMax.set(this.$languages,{opacity: 0, y: 100});

        this.contactsOpen = false;
        common.$body.removeClass('show-contacts');
        this.$contacts.hide();
        TweenMax.set(this.$contacts, { opacity: 0})


    }

    onResize(){

        if(this.open){

            this.$menu.width(common.screen.width);

        }

    }

    touchScroll(e){

        console.log(e.target, e.currentTarget);

    }

    toggle(){

        if(this.open){

            if(this.privacyOpen){
                this.hidePrivacy();
            }else if(this.contactsOpen) {
                this.hideContacts();
            }else{
                this.hide();
            }

            if(this.closeAll){
                this.closeAll = false;
                this.hide();
            }

            if(common.$body.hasClass('show-fullscreen'))
                scroller.disable();

        }else{

            scroller.enable();
            this.show();

        }

    }

    show(){

        let prom = $.Deferred();

        common.$body.addClass('show-menu');
        this.open = true;
        this.$menu.show();

        if($(".LoadBar").hasClass('__show')){
            TweenMax.to($("#main-logo"), 0.5, {x: 0});
        }

        let tl = new TimelineMax({onComplete: () => {
            prom.resolve();
        }});

        tl.add(TweenMax.fromTo(this.$menu, 1, { width: 0 }, { width: common.screen.width, ease: Power4.easeInOut }))
        tl.add(TweenMax.staggerTo(this.$navLi, 0.8, { opacity: 1, ease: Power4.easeInOut }, 0.1))
        tl.add([
            TweenMax.to(this.$reserved, 1, { opacity: 1, y: 0, ease: Power4.easeInOut }),
            TweenMax.to(this.$languages, 1, { opacity: 1, y: 0, ease: Power4.easeInOut })
        ]);

        return prom.promise();

    }

    hide(){

        if($(".LoadBar").hasClass('__show')){
            TweenMax.to($("#main-logo"), 0.5, {x: 100});
        }

        common.$body.removeClass('show-menu');
        this.open = false;
        TweenMax.fromTo(this.$menu, 1, { x: 0 }, { x: common.screen.width * -1, ease: Power4.easeInOut, onComplete: () => {
            this.reset();
        }})

    }

    showContacts(){

        let d = $.Deferred();

        if(this.open){

            d.resolve();

        }else{

            d = this.show();

        }

        d.done(() => {

            this.$contacts.css('display', 'flex');
            this.contactsOpen = true;

            let tl = new TimelineMax({ onComplete: () => {
                common.$body.addClass('show-contacts');
            }});
            tl.add([
                TweenMax.to(this.$navLi, 0.8, { opacity: 0, ease: Power4.easeInOut }),
                TweenMax.to(this.$reserved, 1, { opacity: 0, y: 100, ease: Power4.easeInOut }),
                TweenMax.to(this.$languages, 1, { opacity: 0, y: 100, ease: Power4.easeInOut }),
                TweenMax.to(this.$contacts, 1, { opacity: 1, ease: Power4.easeInOut, delay: 1 })
            ]);

        })

    }

    hideContacts(){

        this.contactsOpen = false;
        common.$body.removeClass('show-contacts');

        let tl = new TimelineMax({onComplete: () => {
            this.$contacts.css('display', 'none');
        }});
        tl.add([
            TweenMax.to(this.$contacts, 1, { opacity: 0, ease: Power4.easeInOut})
        ]);
        tl.add([
            TweenMax.to(this.$navLi, 0.8, { opacity: 1, ease: Power4.easeInOut }),
            TweenMax.to(this.$reserved, 1, { opacity: 1, y: 0, ease: Power4.easeInOut }),
            TweenMax.to(this.$languages, 1, { opacity: 1, y: 0, ease: Power4.easeInOut }),
        ]);


    }

    showContactsSingle(){

        common.$body.addClass('show-menu');
        common.$body.addClass('show-contacts');
        scroller.enable();

        this.$menu.show();
        this.$contacts.css('display','flex');
        this.open = true;
        this.openContacts = true;
        this.closeAll = true;

        if($(".LoadBar").hasClass('__show')){
            TweenMax.to($("#main-logo"), 0.5, {x: 0});
        }

        let tl = new TimelineMax();

        tl.add(TweenMax.fromTo(this.$menu, 1, { width: 0 }, { width: common.screen.width, ease: Power4.easeInOut }))
        tl.add(TweenMax.to(this.$contacts, 1, { opacity: 1, ease: Power4.easeInOut }));

    }


    showPrivacy(e){

        e.preventDefault();
        scroller.enable();
        this.privacyOpen = true;
        this.closeAll = true;

        if(!this.open){
            common.$body.addClass('show-menu');
            this.$menu.show();
        }

        common.$body.addClass('show-privacy');
        this.$privacy.show();


        if($(".LoadBar").hasClass('__show')){
            TweenMax.to($("#main-logo"), 0.5, {x: 0});
        }

        let tl = new TimelineMax();

        if(!this.open)
            tl.add(TweenMax.fromTo(this.$menu, 1, { width: 0 }, { width: common.screen.width, ease: Power4.easeInOut }))

        tl.add(TweenMax.to(this.$privacy, 1, { opacity: 1, ease: Power4.easeInOut }));
        this.open = true;

    }

    hidePrivacy(){

        this.privacyOpen = false;

        TweenMax.to(this.$privacy, 1, { opacity: 0, ease: Power4.easeInOut, onComplete: () => {

            this.$privacy.hide();
            common.$body.removeClass('show-privacy');

        }})

    }

}

export default new Menu();


// WEBPACK FOOTER //
// ./js/layouts/menu.js